import React, { useState, useEffect } from "react";
import moment from "moment";
import { Redirect } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";

import html2canvas from "html2canvas";
import {
  Button,
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import ReactstrapTable from "./../Tables/ReactstrapTable/DataTable";
import { check_Bussiness_Permission } from "../../Helper";
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var customerName = localStorage.getItem("firstName");
var loginId = localStorage.getItem("username");
var companyName = localStorage.getItem("companyName");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
if (loginId === "SJM_Admin@gmail.com") {
  customerName = loginId.toString().replace(":", "").split("@")[0];
}
export default function PrintReports(props) {
  console.log("props :>> ", props);
  const [data, setData] = useState({
    dynamicInvMessage: props?.location?.state?.dynamicInvMessage,
    reportName: props?.location?.state?.reportName,
    table: [],
    companyName: localStorage.getItem("companyName"),
    // date: new Date(),
    criteria: props?.location?.state?.criteria,
    criteriaString: props?.location?.state?.criteriaString || "All",
    hidePdfBtn: props?.location?.state?.hidePdfBtn || 0,
  });

  const [screenTableData, setScreenTableData] = useState([]);
  const [isAACotton, setIsAACotton] = useState(false);
  const [isDollarjnction, setIsDollarjnction] = useState(true);
  useEffect(() => {
    // console.log(props);
    let logInStatus = false;
    const token = localStorage.getItem("token");
    let reportPrintGoBackUrl = localStorage.getItem("reportPrintGoBackUrl");
    console.log(reportPrintGoBackUrl);
    console.log(props?.location?.state?.data);
    // return;
    const screenPrintData = props?.location?.state?.data;
    console.log(screenPrintData);
    if (screenPrintData) {
      const modifiedData = screenPrintData.map((row, index, array) => {
        if (
          index > 0 &&
          row.master_invoice_id === array[index - 1].master_invoice_id &&
          row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM &&
          row.master_invoice_id > -1
        ) {
          return {
            ...row,
            INVOICE_DATE: "",
            INVOICE_NO: "",
            FINISHED_ITEM: "",
          };
        }
        return row;
      });
      setScreenTableData(modifiedData); // Update state instead of a variable
    }
    if (token != null) {
      logInStatus = true;
    }
    if (logInStatus === false) {
      return <Redirect to="/login" />;
    }
    if (!props?.location?.state?.data) {
      props.history.push({
        pathname: reportPrintGoBackUrl,
      });
    } else {
      reportPrintGoBackUrl = props?.location?.state?.goBackUrl;
      localStorage.setItem("reportPrintGoBackUrl", reportPrintGoBackUrl);
    }
    // manipulateData();
    // getdata();
    // getAccountsSummary();
    const funCall = async () => {
      await checkBussinessPermission();
    };
    funCall();
  }, []);

  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    props.history.push({
      pathname: pathName,
    });
  };
  
  // Opt-in (All Branches Stock passes redNegatives): negative body figures in
  // red in the PDFs. Values are pre-formatted strings like "-1,234.00".
  const paintNegativeRed = (cellData) => {
    if (!props?.location?.state?.redNegatives) return;
    if (cellData.section !== "body") return;
    const s = String(cellData.cell.raw ?? "").trim();
    if (s.startsWith("-") && Number(s.replace(/,/g, "")) < 0) {
      cellData.cell.styles.textColor = [220, 53, 69];
    }
  };

  const downloadDollarPDF = () => {
  const alignmentsMaping = props?.location?.state?.headerKeyMap;

  // Grouped pivot (e.g. All Branches Stock): keep the fixed columns plus the
  // Qty leaf of every group; drop each group's Rate/Amount.
  const groupedHeaders = props?.location?.state?.groupedHeaders;
  const mapAlign = (a) =>
    a === "right" ? "right" : a === "left" ? "left" : "center";

  let hiddenIndexes;
  let headers;

  if (groupedHeaders) {
    const row2 = groupedHeaders.row2 || [];
    const totalLeaves = 3 + row2.length; // 3 fixed leaves + group leaves
    hiddenIndexes = [];
    for (let i = 3; i < totalLeaves; i++) {
      if (row2[i - 3]?.label !== "Qty") hiddenIndexes.push(i);
    }

    const fixedCells = groupedHeaders.row1.filter((c) => c.rowSpan);
    const groupCells = groupedHeaders.row1.filter((c) => !c.rowSpan);
    headers = [
      [
        ...fixedCells.map((c) => ({
          content: c.label,
          rowSpan: 2,
          styles: { halign: mapAlign(c.align) },
        })),
        ...groupCells.map((c) => ({
          content: c.label,
          colSpan: 1,
          styles: { halign: "center" },
        })),
      ],
      groupCells.map(() => ({ content: "Qty", styles: { halign: "right" } })),
    ];
  } else {
    // Columns to hide in PDF
    const hideColumns = ["Rate", "Amount", "Last Date"];

    // Prepare headers
    const allHeaders = props?.location?.state?.headers.map((header) =>
      typeof header === "object" && header?.value ? header?.value : header
    );
    // Find indexes of columns to hide
    hiddenIndexes = allHeaders.reduce((acc, header, index) => {
      if (hideColumns.includes(header)) {
        acc.push(index);
      }
      return acc;
    }, []);

    // Filter headers
    headers = [allHeaders.filter((_, index) => !hiddenIndexes.includes(index))];
  }

  // Filter column styles
  const columnStyles = alignmentsMaping
    .filter((_, index) => !hiddenIndexes.includes(index))
    .reduce((acc, item, index) => {
      acc[index] = { halign: item.align || "left" };
      return acc;
    }, {});

  const rawData = props?.location?.state?.data;
  const pdfData = props.location.state.pdfDataArray;
  const pdfDataArray = pdfData ? pdfData : rawData;

  const modifiedPdfDataArray = pdfDataArray.map((row, index, array) => {
    if (
      index > 0 &&
      row.FINISHED_ITEM &&
      row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM
    ) {
      return {
        ...row,
        INVOICE_DATE: "",
        INVOICE_NO: "",
        FINISHED_ITEM: "",
      };
    }

    return row;
  });

  // Filter row values according to hidden columns
const rowsvalueExtracted = modifiedPdfDataArray.map((item) => {
  for (const header of headers[0]) {
    const key = Object.keys(item).find(
      (itemKey) => itemKey.trim() === String(header).trim()
    );

    if (!key) {
      // If any header is not found, break the inner loop
      return Object.values(item);
    }
  }

  // If all headers were found
  return headers[0].map((header) => {
    const key = Object.keys(item).find(
      (itemKey) => itemKey.trim() === String(header).trim()
    );

    return item[key];
  });
});

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a2",
  });

  const reportName = data.reportName;

  const isSupplyReport =
    reportName === "Supply_Register_Report" ||
    reportName === "Supply Register Report";

  const isAACottonSupplyReport = isAACotton && isSupplyReport;

  doc.setFontSize(25);

  if (isAACottonSupplyReport) {
    doc.text("A.A. COTTON MILLS LTD", 14, 10);
    doc.setFontSize(20);
    doc.text(reportName, 14, 20);
  } else {
    doc.text(reportName, 14, 10);
  }

  doc.setFontSize(20);
  doc.text(
    data.criteriaString,
    14,
    isAACottonSupplyReport ? 30 : 20
  );

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US");

  let username = localStorage.getItem("username");
  let companyName = localStorage.getItem("companyName");

  doc.autoTable({
    head: headers,
    body: rowsvalueExtracted,
    startY: isAACottonSupplyReport ? 35 : 22,
    theme: "striped",
    styles: {
      fontSize: isAACottonSupplyReport ? 15 : 20,
      cellPadding: isAACottonSupplyReport ? 4 : 2,
      valign: "middle",
    },
    headStyles: {
      fillColor: [63, 14, 128],
      halign: "center",
      valign: "middle",
      fontStyle: "bold",
    },
    columnStyles,

    didDrawPage: () => {
      doc.text(`Generated By: ${username}`, 340, 410);
      doc.text(`Generated on: ${formattedDate}`, 500, 410);

      doc.text(
        `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
        10,
        410
      );
    },

    didParseCell: (data) => {
      paintNegativeRed(data);
      if (
        data.row.raw[2] === "Sub Total" ||
        data.row.raw[1] === "Total" ||
        data.row.raw[0] === "Total"
      ) {
        data.cell.styles.fontStyle = "bold";
      } else if (
        data.row.raw[1] === "SubTotal" ||
        data.row.raw[1] === "Total Profits" ||
        data.row.raw[1] === "Product Wise Sales" ||
        data.row.raw[1] === "Stock Return" ||
        data.row.raw[1] === "U-Clip Stock Return"
      ) {
        data.cell.styles.fontStyle = "bold";
      }
    },
  });

  doc.save(reportName);
};

  const downloadPDF = () => {
    const alignmentsMaping = props?.location?.state?.headerKeyMap;
    // console.log("alignmentsMaping", alignmentsMaping);
    const columnStyles = alignmentsMaping.reduce((acc, item, index) => {
      acc[index] = { halign: item.align || "left" };
      return acc;
    }, {});
    // console.log(" columnStyles,", columnStyles);
    // const headers = [props?.location?.state?.headers];
    // Grouped headers (e.g. All Branches Stock pivot): render branch names
    // spanning their Qty/Rate/Amount as a 2-row head so many branches stay tidy.
    const groupedHeaders = props?.location?.state?.groupedHeaders;
    const mapAlign = (a) =>
      a === "right" ? "right" : a === "left" ? "left" : "center";
    const headers = groupedHeaders
      ? [
          groupedHeaders.row1.map((c) => ({
            content: c.label,
            colSpan: c.colSpan || 1,
            rowSpan: c.rowSpan || 1,
            styles: { halign: mapAlign(c.align) },
          })),
          groupedHeaders.row2.map((c) => ({
            content: c.label,
            styles: { halign: mapAlign(c.align) },
          })),
        ]
      : [
          props?.location?.state?.headers.map((header) =>
            typeof header === "object" && header?.value ? header?.value : header,
          ),
        ];
    const rawData = props?.location?.state?.data;
    const pdfData = props.location.state.pdfDataArray;
    const pdfDataArray = pdfData ? pdfData : rawData;
    console.log("pdfDataArray :>> ", pdfDataArray);
    const modifiedPdfDataArray = pdfDataArray.map((row, index, array) => {
      // If it's not the first row, compare with the previous row

      if (
        index > 0 &&
        row.FINISHED_ITEM &&
        row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM // Compare `FINISHED_ITEM`
      ) {
        // Set columns to empty strings for the current row
        return {
          ...row,
          INVOICE_DATE: "",
          INVOICE_NO: "",
          FINISHED_ITEM: "",
        };
      }
      // Otherwise, return the row as-is
      return row;
    });

    console.log(modifiedPdfDataArray);
const rowsvalueExtracted = modifiedPdfDataArray.map((item) => {
  for (const header of headers[0]) {
    const key = Object.keys(item).find(
      (itemKey) => itemKey.trim() === String(header).trim()
    );

    if (!key) {
      // If any header is not found, break the inner loop
      return Object.values(item);
    }
  }

  // If all headers were found
  return headers[0].map((header) => {
    const key = Object.keys(item).find(
      (itemKey) => itemKey.trim() === String(header).trim()
    );

    return item[key];
  });
});

console.log("headers:", headers);
console.log("rowsvalueExtracted:", rowsvalueExtracted);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });
    const reportName = data.reportName; // Replace with your actual report name
    const isSupplyReport =
      reportName === "Supply_Register_Report" ||
      reportName === "Supply Register Report";
    const isAACottonSupplyReport = isAACotton && isSupplyReport;
    doc.setFontSize(25);
    if (isAACottonSupplyReport) {
      doc.text("A.A. COTTON MILLS LTD", 14, 10);
      doc.setFontSize(20);
      doc.text(reportName, 14, 20);
    } else {
      doc.text(reportName, 14, 10); // Add a title
    }
    doc.setFontSize(20);
    doc.text(data.criteriaString, 14, isAACottonSupplyReport ? 30 : 20); // Add a title
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US");
    let username = localStorage.getItem("username");
    let companyName = localStorage.getItem("companyName");
    // Generate the table
    doc.autoTable({
      head: headers,
      body: rowsvalueExtracted,
      startY: isAACottonSupplyReport ? 35 : 22,
      theme: "striped",
      styles: {
        fontSize: isAACottonSupplyReport ? 15 : 20,
        cellPadding: isAACottonSupplyReport ? 4 : 2,
        valign: "middle",
      },
      headStyles: {
        fillColor: [63, 14, 128],
        halign: "center", // or 'left' / 'right'
        valign: "middle", // vertical alignment
        fontStyle: "bold",
      },
      columnStyles,
      didDrawPage: (data) => {
        // if (companyName === "Dollar Junction") {
        doc.text(`Generated By: ${username}`, 340, 410);
        doc.text(`Generated on: ${formattedDate}`, 500, 410);
        // }

        // Footer example
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
          10,
          410,
        );
      },
      didParseCell: (data) => {
        paintNegativeRed(data);
        // Check the conditions for bolding the rows
        if (
          data.row.raw[2] === "Sub Total" || // Check if the third column is "Sub Total"
          data.row.raw[1] === "Total" || // Check if the first column is "Total"
          data.row.raw[0] === "Total" // Check if the first column is "Total"
        ) {
          data.cell.styles.fontStyle = "bold"; // Apply bold style
        } else if (
          data.row.raw[1] === "SubTotal" || // Check if the 2 column is "Sub Total"
          data.row.raw[1] === "Total Profits" || // Check if the 2 column is "Total"
          data.row.raw[1] === "Product Wise Sales" || // Check if the 2 column is "Total"
          data.row.raw[1] === "Stock Return" || // Check if the 2 column is "Total"
          data.row.raw[1] === "U-Clip Stock Return" // Check if the 2 column is "Total"
        ) {
          data.cell.styles.fontStyle = "bold"; // Apply bold style
        }
      },
    });

    // Save the PDF
    doc.save(reportName);
  };
  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    let { isAACotton, isDollarjnction } = checkBussinessPermission;
    if (isAACotton) {
      setIsAACotton(true);
    }
    if (isDollarjnction) {
      
      setIsDollarjnction(false);
    }
  };

  const {
    companyName,
    dynamicInvMessage,
    reportName,
    criteria,
    criteriaString,
  } = data;
  return (
    <>
      <Row id="app-body-Invoice" className="app-body-Invoice mt-3">
        <Col xs="12">
          <Row>
            <Col xs="6">
              {" "}
              <h2 style={{ marginLeft: "5px" }} className="">
                {isAACotton ? "A.A. COTTON MILLS LTD" : companyName}
              </h2>{" "}
            </Col>
            <Col xs="4">
              <span style={{ marginLeft: "13em" }}>
                <span className=" ">Printed By </span>: (
                <span className="text-success"> {customerName} </span> )
              </span>
            </Col>
            <Col xs="2">
              <span style={{ marginLeft: "0rem" }}>
                <span className=" ">Printed Date </span>: (
                <span className="text-success"> {currentDate} </span> )
              </span>
            </Col>
            <Col xs="8">
              {" "}
              <h3 style={{ marginLeft: "5px" }} className="">
                {dynamicInvMessage}
              </h3>{" "}
            </Col>
            <Col xs="4">
              <div style={{ textAlign: "end" }}>
                {
                  //Friday 13 Dec, 2024  previous print set Conditionally and
                  //New Print PDF button added by Muhammad Ahmad On all reports With Reports Criteria
                }
                {data.hidePdfBtn > 0 ? (
                  <button
                    className="btn btn-primary mx-2"
                    id="printPageButton"
                    onClick={() => {
                      window.document.title = reportName;
                      window.print();
                    }}
                  >
                    Print to PDF!
                  </button>
                ) : (
                  <>
                  <Button className="btn btn-warning" onClick={downloadPDF}>
                    Print PDF
                  </Button>
                  <Button hidden={isDollarjnction} className="btn btn-info mx-2" onClick={downloadDollarPDF}>
                    Print Only Qty PDF!
                  </Button>
                  </>
                )}
                <button
                  className="btn btn-secondary m-1"
                  id="printPageButton"
                  onClick={() => {
                    goBackFun();
                  }}
                >
                  Back
                </button>
              </div>{" "}
            </Col>

            <Col xs="12">
              <p style={{ marginLeft: "5px" }}>
                <b>Data Criteria: {criteriaString}</b>
              </p>
              {/* {criteria?.map((element, index) => (
                <>
                  <span>
                    {element?.label +
                      ": " +
                      element?.value +
                      (index === criteria?.length - 1 ? "" : ", ")}{" "}
                  </span>
                  {index == 3 ? <br></br> : null}
                </>
              ))} */}
            </Col>
            {screenTableData.length > 0 ? (
              <Col xs="12">
                <ReactstrapTable
                  data={screenTableData}
                  headers={props?.location?.state?.headers}
                  username={props?.location?.state?.username}
                  headerKeyMap={props?.location?.state?.headerKeyMap}
                  groupedHeaders={props?.location?.state?.groupedHeaders}
                  totalBold={props?.location?.state?.totalBold}
                  redNegatives={props?.location?.state?.redNegatives}
                />
              </Col>
            ) : (
              <p>Loading data...</p>
            )}
            <Col xs="12">
              <p>
                * <span className="text-danger">Note </span>: All figures
                indicated are in the company's currency (
                <span className="text-success"> {companySymbolCurrency} </span>{" "}
                ) .{" "}
              </p>
            </Col>
          </Row>
          <br></br>
        </Col>
      </Row>
    </>
  );
}
